/* eslint-disable
    block-scoped-var,
    default-case,
    no-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {EventConstants} from 'constants/EventConstants';
import * as browser from 'lib/Browser';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';
import {Link} from 'link-preview/LinkDAO';
import throttle, {ThrottledFunction} from 'util/throttle';

class LinkStore extends Store {
  unprocessed!: Array<string>;
  previews!: Record<string, Link>;
  refcounts!: Record<string, number>;
  _throttledFetchLinks!: ThrottledFunction<() => void>;

  resetState(): void {
    this.unprocessed = [];
    this.previews = {};
    this.refcounts = {};
    // _.throttle is stateful (it closures a variable to track the time it was last fired), so we reset it by
    // re-creating the throttled function.
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this._throttledFetchLinks = throttle(this._fetchLinks, 50, {leading: false});
  }

  getFileIdForUrl(url: string): string | null {
    // eslint-disable-next-line benchlint/no-in-operator
    if (!(url in this.previews)) {
      return null;
    }
    return this.previews[url].id;
  }

  _fetchLinks(): void {
    const LinkActions = require('./LinkActions').default;
    if (!browser.isBrowser) {
      // Don't fetchLinks in non-browser environments since jQuery doesn't exist
      return;
    }
    const urls = this.unprocessed;
    if (urls.length === 0) {
      return;
    }
    this.unprocessed = [];
    LinkActions.fetchPreviews(urls);
  }

  _addLinkForProcessing(url: string): void {
    this.unprocessed.push(url);
    this._throttledFetchLinks();
  }

  payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.LINK_PREVIEWS_FETCHED: {
        // If a preview that was returned is still being tracked, store the preview.
        for (const preview of Array.from(action.previews)) {
          // eslint-disable-next-line benchlint/no-in-operator
          if (preview.url in this.refcounts) {
            this.previews[preview.url] = preview;
          }
        }
        this.emitChange();
        break;
      }

      case EventConstants.LINK_SYNC:
        // Maintain refcounts. For any new refs, add it for processing. For any dead refs, clean up
        // state to prevent memory from growing unboundedly.
        for (var url of Array.from(action.added)) {
          // eslint-disable-next-line benchlint/no-in-operator
          if (!(url in this.refcounts)) {
            this.refcounts[url] = 1;
            this._addLinkForProcessing(url);
          } else {
            this.refcounts[url]++;
          }
        }
        for (url of Array.from(action.removed)) {
          this.refcounts[url] -= 1;
          if (this.refcounts[url] === 0) {
            delete this.refcounts[url];
            delete this.previews[url];
          }
        }
        this.emitChange();
        break;
    }

    return true;
  }
}

export default new LinkStore(AppDispatcher);
